// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom scrollbar for ChargerTimeline */
.charger-timeline-scroll {
    /* Firefox scrollbar support */
    scrollbar-width: thin;
    scrollbar-color: #9ca3af #f3f4f6;
}

/* Webkit browsers (Chrome, Safari, Edge) scrollbar support */
.charger-timeline-scroll::-webkit-scrollbar {
    width: 8px;
}

.charger-timeline-scroll::-webkit-scrollbar-track {
    background: #f3f4f6;
    border-radius: 4px;
}

.charger-timeline-scroll::-webkit-scrollbar-thumb {
    background: #9ca3af;
    border-radius: 4px;
}

.charger-timeline-scroll::-webkit-scrollbar-thumb:hover {
    background: #6b7280;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChargerTimeline/ChargerTimeline.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;IACI,8BAA8B;IAC9B,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA,6DAA6D;AAC7D;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["/* Custom scrollbar for ChargerTimeline */\n.charger-timeline-scroll {\n    /* Firefox scrollbar support */\n    scrollbar-width: thin;\n    scrollbar-color: #9ca3af #f3f4f6;\n}\n\n/* Webkit browsers (Chrome, Safari, Edge) scrollbar support */\n.charger-timeline-scroll::-webkit-scrollbar {\n    width: 8px;\n}\n\n.charger-timeline-scroll::-webkit-scrollbar-track {\n    background: #f3f4f6;\n    border-radius: 4px;\n}\n\n.charger-timeline-scroll::-webkit-scrollbar-thumb {\n    background: #9ca3af;\n    border-radius: 4px;\n}\n\n.charger-timeline-scroll::-webkit-scrollbar-thumb:hover {\n    background: #6b7280;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
